const createLineItemId = (orderLineItem) => {
  try {
    return window.btoa(
      JSON.stringify({
        sku: orderLineItem.product.sku,
        meta: orderLineItem.__typename === "OrderLineItemContactLens" && orderLineItem.isSubscription ? orderLineItem.prescription : orderLineItem.lineItemNumber,
        quantity: orderLineItem.quantity
      })
    );
  } catch (e) {
    console.error(e);
    return `${orderLineItem.product.sku}`;
  }
};
export {
  createLineItemId
};
//# sourceMappingURL=create-line-item-id.js.map
